import React, { useEffect } from 'react'
import Cookies from 'js-cookie'
import { updateAnalyticsConsent } from '../../utils/analyticsConsent'
import { AppProvider } from '../../context/app-context'
import { ToastContainer } from 'react-toastify'

const RootLayout = ({ children }) => {
    useEffect(() => {
        updateAnalyticsConsent(Cookies.get('gatsby-gdpr-google-analytics') === 'true')
    }, [])
    return <AppProvider>{children}<ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" /></AppProvider>
}

export default RootLayout
